<template>
  <div class="home" @scroll="windowScroll($event)">
    <Header :headerStyle="headerStyle" @open-modal="openModal" />
    <!-- <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48"
        width="30"
        height="30"
        style="position:fixed; z-index:0; left:50%; top: 20%"
        class="animated fadeInDownBig"
      >
        <path d="M 48 0 L 24 48 L 0 0 Z" fill="rgba(0,0,0,0.05)"></path>
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48"
        width="10"
        height="10"
        style="position:fixed; z-index:0; left:49%; top: 15%"
        class="animated fadeInDown"
      >
        <path d="M 48 0 L 24 48 L 0 0 Z" fill="#a88add"></path>
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48"
        width="5"
        height="5"
        style="position:fixed; z-index:0; left:30%; top: 0%"
        class="animated fadeInDown"
      >
        <path d="M 48 0 L 24 48 L 0 0 Z" fill="#a88add"></path>
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48"
        width="20"
        height="20"
        style="position:fixed; z-index:0; right:5%; top: 30%"
        class="animated fadeInDown"
      >
        <path d="M 48 0 L 24 48 L 0 0 Z" fill="#0cc2aa"></path>
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48"
        width="15"
        height="15"
        style="position:fixed; z-index:0; left:34.5%; top: 55%"
        class="animated fadeIn"
      >
        <path d="M 0 48 L 24 0 L 48 48 Z" fill="#fcc100"></path>
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48"
        width="200"
        height="200"
        style="position:fixed; z-index:0; right:20%; top: 70%"
        class="animated fadeInUp"
      >
        <path d="M 0 48 L 24 0 L 48 48 Z" fill="rgba(252,193,0,0.1)"></path>
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48"
        width="120"
        height="120"
        style="position:fixed; z-index:0; left:0%; top: 30%"
        class="animated fadeInLeftBig"
      >
        <path d="M 0 48 L 48 24 L 0 0 Z" fill="rgba(0,0,0,0.03)"></path>
      </svg>
    </div>-->
    <div class="page-content" id="home">
      <swiper :options="topBannerOption" class="hidden-xs-down" id="1">
        <swiper-slide v-for="item in bannerList" :key="item.id">
          <div class>
            <div :class="item.banner_style">
              <div class="row-cell v-b">
                <div class="container p-y-lg pos-rlt text-white">
                  <h1 class="display-3 _700 l-s-n-3x m-t-lg m-b-md text-shadow hidden-xs-down">跨境供应链解决方案专家</h1>
                  <h5 class="m-b-md text-shadow desc">
                    欧城记跨境电商是专业运营跨境电商的服务平台，拥有5年以上跨境电商平台运营经验。同时是京东、考拉、蜜芽第一批海外货源供应商，
                    我们提供完善的"采-运-储-销"一站式服务，做到真正的贸易供应链一体化闭环
                  </h5>
                  <button class="btn btn-lg primary text-white" data-toggle="modal" data-target="#m">入驻欧城记商户平台</button>
                  <!-- <a href="https://mini.eurcd.com" target="_blank" class="btn btn-lg primary text-white
                   b-2x">
                  入驻欧城记商户平台</a>-->
                </div>
              </div>
            </div>
          </div>
        </swiper-slide>
        <!-- <div class="swiper-pagination" slot="pagination"></div> -->
      </swiper>
      <div class="row-cell v-b hidden-sm-up">
        <div class="container p-y-lg pos-rlt text-white">
          <h2 class="_700 l-s-n-3x m-t-lg m-b-md text-dark">跨境供应链解决方案专家</h2>
          <h5 class="m-b-md desc text-dark">
            欧城记跨境电商是专业运营跨境电商的服务平台，拥有5年以上跨境电商平台运营经验。同时是京东、考拉、蜜芽第一批海外货源供应商，
            我们提供完善的"采-运-储-销"一站式服务，做到真正的贸易供应链一体化闭环
          </h5>
          <a href="https://mini.eurcd.com" target="_blank" class="btn btn-lg primary text-white b-2x">入驻欧城记商户平台</a>
        </div>
      </div>

      <div class="p-y text-center m-t-lg" id="solution">
        <div class="container p-y">
          <h2 class="_700 l-s-n-1x m-b">
            跨境供应链解决方案
            <span class="text-dark block h4">Cross-border Supply Chain Solutions</span>
          </h2>

          <div class="row m-y-lg">
            <div class="col-xs-6 col-sm-4 col-md-4">
              <div class="box p-a-xs">
                <a href="#">
                  <img src="http://images.eurcd.com/web/images/002.jpeg" alt class="img-responsive r-a r-3x" />
                </a>
                <div class="p-a">
                  <div class="_800 text-md">优势一: 海外一手资源</div>
                </div>
              </div>
            </div>
            <div class="col-xs-6 col-sm-4 col-md-4">
              <div class="box p-a-xs">
                <a href="#">
                  <img src="http://images.eurcd.com/web/images/003.jpeg" alt class="img-responsive r-a r-3x" />
                </a>
                <div class="p-a">
                  <div class="_800 text-md">优势二: 中欧班列会员单位</div>
                </div>
              </div>
            </div>
            <div class="col-xs-6 col-sm-4 col-md-4">
              <div class="box p-a-xs">
                <a href="#">
                  <img src="http://images.eurcd.com/web/images/005.jpeg" alt class="img-responsive r-a r-3x" />
                </a>
                <div class="p-a">
                  <div class="_800 text-md">优势三: 航空代理企业</div>
                </div>
              </div>
            </div>
            <div class="col-xs-6 col-sm-4 col-md-4">
              <div class="box p-a-xs">
                <a href="#">
                  <img src="http://images.eurcd.com/web/images/004.jpeg" alt class="img-responsive r-a r-3x" />
                </a>
                <div class="p-a">
                  <div class="_800 text-md">优势四: 自建保税发货仓</div>
                </div>
              </div>
            </div>
            <div class="col-xs-6 col-sm-4 col-md-4">
              <div class="box p-a-xs">
                <a href="#">
                  <img src="http://images.eurcd.com/web/images/006.jpeg" alt class="img-responsive r-a r-3x" />
                </a>
                <div class="p-a">
                  <div class="_800 text-md">优势五: 高效一件代发</div>
                </div>
              </div>
            </div>
            <div class="col-xs-6 col-sm-4 col-md-4">
              <div class="box p-a-xs">
                <a href="#">
                  <img src="http://images.eurcd.com/web/images/001.jpeg" alt class="img-responsive r-a r-3x" />
                </a>
                <div class="p-a">
                  <div class="_800 text-md">优势六: 门店C端分销</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="p-y text-center" id="join">
        <div class="container">
          <h2 class="_700 l-s-n-1x m-b">
            招商加盟
            <span class="text-dark block h4">Merchants Join</span>
          </h2>
          <div class="row m-y-lg">
            <div
              class="col-md-8 col-md-offset-2"
            >2018年12月25日四川欧城记跨境电子商务有限公司与成都青白江区商务局达成跨境电商战略合作协议，依托成都中欧班列、航运枢纽等功能、充分发挥企业自身海外一手货源、保税仓运营、国内线下门店等优势，力求把企业打造成跨境供应链行业标杆型企业。</div>
          </div>
        </div>
      </div>
      <div class="p-y-sm text-center m-b-md" id="join">
        <div class="container">
          <div class="h3 _700 l-s-n-1x m-b">商户入驻流程</div>
          <div class="row m-y-lg">
            <div class="col-md-12">
              <div class="row">
                <div class="col-sm-3 col-xs-6 m-b-md">
                  <img src="../../public/img/images/b01.png" style="width:100px" />
                  <div class="h4 m-t-md">提交申请</div>
                  <div>填写商户资料，提交审核</div>
                </div>
                <div class="col-sm-3 col-xs-6 m-b-md">
                  <img src="../../public/img/images/b02.png" style="width:100px" />
                  <div class="h4 m-t-md">资质审核</div>
                  <div>欧城记专员联系商户审查</div>
                </div>
                <div class="col-sm-3 col-xs-6 m-b-md">
                  <img src="../../public/img/images/b03.png" style="width:100px" />
                  <div class="h4 m-t-md">签约, 确认入驻</div>
                  <div>生成专属小程序码和邀请码</div>
                </div>
                <div class="col-sm-3 col-xs-6 m-b-md">
                  <img src="../../public/img/images/b04.png" style="width:100px" />
                  <div class="h4 m-t-md">入驻完成</div>
                  <div>进入商户管理系统</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="p-y text-center" id="about">
        <div class="container">
          <h2 class="_700 l-s-n-1x m-b">
            关于欧城记
            <span class="text-dark block h4">About Us</span>
          </h2>

          <div class="row hidden-sm-up">
            <div class="col-xs-6">
              <div class="padding pos-rlt">
                <img src="../../public/img/images/a05.png" style="width:90px" />
                <div class="m-t _700 h4">专业</div>
                <span class="block m-t-sm">跨境供应链服务专家</span>
              </div>
            </div>
            <div class="col-xs-6">
              <div class="padding pos-rlt">
                <img src="../../public/img/images/a02.png" style="width:90px" />
                <div class="m-t _700 h4">创新</div>
                <span class="block m-t-sm">平台分享经济类型</span>
              </div>
            </div>
            <div class="col-xs-6">
              <div class="padding pos-rlt">
                <img src="../../public/img/images/a03.png" style="width:90px" />
                <div class="m-t _700 h4">高效</div>
                <span class="block m-t-sm">货源、保税仓储综合服务</span>
              </div>
            </div>
            <div class="col-xs-6">
              <div class="padding pos-rlt">
                <img src="../../public/img/images/a04.png" style="width:90px" />
                <div class="m-t _700 h4">共享</div>
                <span class="block m-t-sm">平台优质货源共享</span>
              </div>
            </div>
          </div>
          <div class="row-col hidden-xs-down">
            <div class="col-sm">
              <div class="padding pos-rlt">
                <img src="../../public/img/images/a05.png" style="width:90px" />
                <div class="m-t _700 h4">专业</div>
                <span class="block m-t-sm">跨境供应链服务专家</span>
              </div>
            </div>
            <div class="col-sm">
              <div class="padding pos-rlt">
                <img src="../../public/img/images/a02.png" style="width:90px" />
                <div class="m-t _700 h4">创新</div>
                <span class="block m-t-sm">平台分享经济类型</span>
              </div>
            </div>
            <div class="col-sm">
              <div class="padding pos-rlt">
                <img src="../../public/img/images/a03.png" style="width:90px" />
                <div class="m-t _700 h4">高效</div>
                <span class="block m-t-sm">货源、保税仓储综合服务</span>
              </div>
            </div>
            <div class="col-sm">
              <div class="padding pos-rlt">
                <img src="../../public/img/images/a04.png" style="width:90px" />
                <div class="m-t _700 h4">共享</div>
                <span class="block m-t-sm">平台优质货源共享</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="p-y text-center m-t-lg" id="about">
        <div class="container">
          <h2 class="_700 l-s-n-1x m-b">
            合作伙伴
            <span class="text-dark block h4">Cooperative Partner</span>
          </h2>
          <div class="m-b">欧城记与DM、双心、芭乐雅等众多品牌保持着长期稳定的合作伙伴关系，也在探讨行业趋势并进一步深化合作</div>

          <div class="row hidden-sm-up">
            <div class="col-xs-6">
              <div class="padding pos-rlt">
                <img src="../../public/img/brands/1.png" style="width:150px" />
              </div>
            </div>
            <div class="col-xs-6">
              <div class="padding pos-rlt">
                <img src="../../public/img/brands/3.png" style="width:150px" />
              </div>
            </div>
            <div class="col-xs-6">
              <div class="padding pos-rlt">
                <img src="../../public/img/brands/4.png" style="width:150px" />
              </div>
            </div>
            <div class="col-xs-6">
              <div class="padding pos-rlt">
                <img src="../../public/img/brands/5.png" style="width:150px" />
              </div>
            </div>
            <div class="col-xs-6">
              <div class="padding pos-rlt">
                <img src="../../public/img/brands/6.png" style="width:150px" />
              </div>
            </div>
            <div class="col-xs-6">
              <div class="padding pos-rlt">
                <img src="../../public/img/brands/2.png" style="width:150px" />
              </div>
            </div>
            <div class="col-xs-6">
              <div class="padding pos-rlt">
                <img src="../../public/img/brands/7.png" style="width:150px" />
              </div>
            </div>
            <div class="col-xs-6">
              <div class="padding pos-rlt">
                <img src="../../public/img/brands/8.png" style="width:150px" />
              </div>
            </div>
            <div class="col-xs-6">
              <div class="padding pos-rlt">
                <img src="../../public/img/brands/9.png" style="width:150px" />
              </div>
            </div>
            <div class="col-xs-6">
              <div class="padding pos-rlt">
                <img src="../../public/img/brands/10.png" style="width:150px" />
              </div>
            </div>
          </div>
          <div class="row-col hidden-xs-down">
            <div class="col-sm">
              <div class="padding pos-rlt">
                <img src="../../public/img/brands/1.png" style="width:150px" />
              </div>
            </div>
            <div class="col-sm">
              <div class="padding pos-rlt">
                <img src="../../public/img/brands/3.png" style="width:150px" />
              </div>
            </div>
            <div class="col-sm">
              <div class="padding pos-rlt">
                <img src="../../public/img/brands/4.png" style="width:150px" />
              </div>
            </div>
            <div class="col-sm">
              <div class="padding pos-rlt">
                <img src="../../public/img/brands/5.png" style="width:150px" />
              </div>
            </div>
            <div class="col-sm">
              <div class="padding pos-rlt">
                <img src="../../public/img/brands/6.png" style="width:150px" />
              </div>
            </div>
          </div>
          <div class="row-col hidden-xs-down">
            <div class="col-sm">
              <div class="padding pos-rlt">
                <img src="../../public/img/brands/2.png" style="width:150px" />
              </div>
            </div>
            <div class="col-sm">
              <div class="padding pos-rlt">
                <img src="../../public/img/brands/7.png" style="width:150px" />
              </div>
            </div>
            <div class="col-sm">
              <div class="padding pos-rlt">
                <img src="../../public/img/brands/8.png" style="width:150px" />
              </div>
            </div>
            <div class="col-sm">
              <div class="padding pos-rlt">
                <img src="../../public/img/brands/9.png" style="width:150px" />
              </div>
            </div>
            <div class="col-sm">
              <div class="padding pos-rlt">
                <img src="../../public/img/brands/10.png" style="width:150px" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="p-y text-center m-t-lg" id="contact">
        <div class="container">
          <h2 class="_700 l-s-n-1x m-b-md">
            联系我们
            <span class="text-dark block h4">Contact</span>
          </h2>
          <div class="row m-y-lg">
            <div class="col-md-3 col-xs-6 m-b-md">
              <span class="h1 block">
                <i class="fa fa-qq"></i>
              </span>
              <span class="block m-t-sm _700">
                QQ咨询
                <br />824864175
                <br />245152358
              </span>
            </div>
            <div class="col-md-3 col-xs-6 m-b-md">
              <span class="h1 block">
                <i class="fa fa-envelope"></i>
              </span>
              <span class="block m-t-sm _700">
                Email
                <br />choctan@sina.com
                <br />sales@railtec-log.com
              </span>
            </div>
            <div class="col-md-3 col-xs-6 m-b-md">
              <span class="h1 block">
                <i class="fa fa-map-marker"></i>
              </span>
              <span class="block m-t-sm _700">
                公司地址
                <br />四川省成都市高新区蜀锦路88号
                <br />楚峰国际中心3503
              </span>
            </div>
            <div class="col-md-3 col-xs-6 m-b-md">
              <span class="h1 block">
                <i class="fa fa-phone-square"></i>
              </span>
              <span class="block m-t-sm _700">
                入助热线
                <br />周一至周五 9:00-18:00
                <br />182 2340 5447
                <br />173 6019 0854
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
    <div id="m" class="modal" data-backdrop="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">温馨提示</h5>
          </div>
          <div class="modal-body text-center p-lg">
            <p class="m-b-0">商户平台正在内测中, 如需体验，请联系客服索要邀请码</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn dark-white p-x-md" data-dismiss="modal">关闭</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'home',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      bannerList: [
        {
          id: 1,
          banner_style: 'h-v row-col banner-bg-1'
        },
        {
          id: 2,
          banner_style: 'h-v row-col banner-bg-2'
        },
        {
          id: 3,
          banner_style: 'h-v row-col banner-bg-3'
        },
        {
          id: 4,
          banner_style: 'h-v row-col banner-bg-4'
        }
      ],
      topBannerOption: {
        autoplay: true,
        loop: true,
        pagination: {
          el: '.swiper-pagination'
        },
        effect: 'fade',
        fadeEffect: true
      },
      headerStyle: 'navbar navbar-md navbar-fixed-top no-bg text-white'
    }
  },
  methods: {
    windowScroll() {
      //滚动条距离页面顶部的距离
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop //原生兼容
      console.log(scrollTop)
      if (scrollTop > 10) {
        this.headerStyle = 'navbar navbar-md navbar-fixed-top primary text-white'
      } else {
        this.headerStyle = 'navbar navbar-md navbar-fixed-top no-bg text-white'
      }
    },
    openModal() {
      console.log('hello')
      $('#m').modal('show')
    }
  },
  mounted() {
    window.addEventListener('scroll', this.windowScroll)
  }
}
</script>
<style scoped>
.banner-bg-1 {
  background-image: url('http://images.eurcd.com/homepage/banner/banner1.jpeg');
  background-repeat: no-repeat;
  background-size: 100%;
}
.banner-bg-2 {
  background-image: url('http://images.eurcd.com/homepage/banner/banner2.jpeg');
  background-repeat: no-repeat;
  background-size: 100%;
}
.banner-bg-3 {
  background-image: url('http://images.eurcd.com/homepage/banner/banner3.jpeg');
  background-repeat: no-repeat;
  background-size: 100%;
}
.banner-bg-4 {
  background-image: url('http://images.eurcd.com/homepage/banner/banner4.jpeg');
  background-repeat: no-repeat;
  background-size: 100%;
}
.text-shadow {
  text-shadow: 0px 0 8px #333333;
}
.desc {
  line-height: 28px;
}
</style>
